import { render, staticRenderFns } from "./Fbacode.vue?vue&type=template&id=3e0903bc&"
import script from "./Fbacode.vue?vue&type=script&lang=js&"
export * from "./Fbacode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports